import ConfirmationPopup from "components/Modals/ConfirmationPopV2";
import React from "react";
import { createRoot } from "react-dom/client";

// Function to trigger confirmation dialog
const confirmDialogV2 = (props) => {
  return new Promise((resolve, reject) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);

    const root = createRoot(modalContainer);

    const handleConfirm = () => {
      root.unmount();
      document.body.removeChild(modalContainer);
      resolve(true);
    };

    const handleCancel = () => {
      root.unmount();
      document.body.removeChild(modalContainer);
      resolve(false);
    };

    root.render(
      <ConfirmationPopup
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        {...props}
      />
    );
  });
};

export default confirmDialogV2;
